module.exports = __webpack_public_path__ + "static/media/arrow-right-light.f87fbcbf.svg";